import {
  ADD_FEE,
  ADD_FEE_COMPLETED,
  ADD_FEE_FAILED,
  ADD_FEE_RATE,
  ADD_FEE_RATE_COMPLETED,
  ADD_FEE_RATE_FAILED,
  GET_FEE,
  SEARCH_FEE_APPLICABLE_PRODUCTS,
  SEARCH_FEE_APPLICABLE_PRODUCTS_COMPLETED,
  SEARCH_FEE_APPLICABLE_PRODUCTS_FAILED,
  GET_FEE_COMPLETED,
  GET_FEE_FAILED,
  GET_FEE_RATES,
  GET_FEE_RATES_COMPLETED,
  GET_FEE_RATES_FAILED,
  SEARCH_FEES,
  SEARCH_FEES_COMPLETED,
  SEARCH_FEES_FAILED,
  UPDATE_FEE,
  UPDATE_FEE_COMPLETED,
  UPDATE_FEE_FAILED,
  FEE_SEARCH_PRODUCTS,
  FEE_SEARCH_PRODUCTS_COMPLETED,
  FEE_SEARCH_PRODUCTS_FAILED,
  ADD_APPLICABLE_PRODUCT_FOR_FEE,
  ADD_APPLICABLE_PRODUCT_FOR_FEE_COMPLETED, ADD_APPLICABLE_PRODUCT_FOR_FEE_FAILED
} from "./actions";
import {handleSearch, handleSearchCompleted, handleSearchFailed, searchDefault} from "../utils/search";
import {firstPage, getPaginationOrDefault} from "../utils/pagination";

const defaultState = {
  searchFees: searchDefault,
  addingFee: false,
  fee: null,
  feeLoading: false,
  updatingFee: false,
  feeRates: [],
  feeRatesLoading: false,
  feeRatesPagination: firstPage,
  addingFeeRate: false,
  searchFeeApplicableProducts: searchDefault,
  productsSearch: searchDefault,
  addingApplicableProduct: false,
  error: null,
};

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case SEARCH_FEES:
      return handleSearch(state, 'searchFees', action.payload);
    case SEARCH_FEES_COMPLETED:
      return handleSearchCompleted(state, 'searchFees', action.payload);
    case SEARCH_FEES_FAILED:
      return handleSearchFailed(state, 'searchFees', action.payload);
    case GET_FEE:
      return {...state, feeLoading: true};
    case GET_FEE_COMPLETED:
      return {...state, feeLoading: false, fee: action.payload};
    case GET_FEE_FAILED:
      return {...state, feeLoading: false, error: action.payload};
    case ADD_FEE:
      return {...state, addingFee: true};
    case ADD_FEE_COMPLETED:
      return {...state, addingFee: false};
    case ADD_FEE_FAILED:
      return {...state, addingFee: false, error: action.payload};
    case UPDATE_FEE:
      return {...state, updatingFee: true};
    case UPDATE_FEE_COMPLETED:
      return {...state, updatingFee: false};
    case UPDATE_FEE_FAILED:
      return {...state, updatingFee: false, error: action.payload};
    case GET_FEE_RATES:
      return {...state, feeRatesLoading: true};
    case GET_FEE_RATES_COMPLETED:
      return {
        ...state,
        feeRatesLoading: false,
        feeRates: action.payload.data,
        feeRatesPagination: getPaginationOrDefault(action.payload)
      };
    case GET_FEE_RATES_FAILED:
      return {...state, feeRatesLoading: false, error: action.payload};
    case ADD_FEE_RATE:
      return {...state, addingFeeRate: true};
    case ADD_FEE_RATE_COMPLETED:
      return {...state, addingFeeRate: false};
    case ADD_FEE_RATE_FAILED:
      return {...state, addingFeeRate: false, error: action.payload};
    case SEARCH_FEE_APPLICABLE_PRODUCTS:
      return handleSearch(state, 'searchFeeApplicableProducts', action.payload);
    case SEARCH_FEE_APPLICABLE_PRODUCTS_COMPLETED:
      return handleSearchCompleted(state, 'searchFeeApplicableProducts', action.payload);
    case SEARCH_FEE_APPLICABLE_PRODUCTS_FAILED:
      return handleSearchFailed(state, 'searchFeeApplicableProducts', action.payload);
    case FEE_SEARCH_PRODUCTS:
      return handleSearch(state, 'productsSearch', action.payload);
    case FEE_SEARCH_PRODUCTS_COMPLETED:
      return handleSearchCompleted(state, 'productsSearch', action.payload);
    case FEE_SEARCH_PRODUCTS_FAILED:
      return handleSearchFailed(state, 'productsSearch', action.payload);
    case ADD_APPLICABLE_PRODUCT_FOR_FEE:
      return {...state, addingApplicableProduct: true};
    case ADD_APPLICABLE_PRODUCT_FOR_FEE_COMPLETED:
      return {...state, addingApplicableProduct: false};
    case ADD_APPLICABLE_PRODUCT_FOR_FEE_FAILED:
      return {...state, addingApplicableProduct: false, error: action.payload};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/Fee/reducer.js